/* After Dark: the Index panel and small header behaviours. Sense's own scripts (cart, search, variants) are untouched. */
(function () {
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ix = document.getElementById('DkIndex');
  const openers = document.querySelectorAll('[data-dk-index]');
  let lastFocus = null;

  const open = () => {
    if (!ix) return;
    lastFocus = document.activeElement;
    ix.hidden = false;
    requestAnimationFrame(() => ix.classList.add('is-open'));
    document.documentElement.style.overflow = 'hidden';
    openers.forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const first = ix.querySelector('[data-dk-index-close]');
    if (first) first.focus({ preventScroll: true });
  };
  const close = () => {
    if (!ix || ix.hidden) return;
    ix.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    openers.forEach((b) => b.setAttribute('aria-expanded', 'false'));
    setTimeout(() => { if (!ix.classList.contains('is-open')) ix.hidden = true; }, 500);
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-dk-index]')) open();
    if (e.target.closest('[data-dk-index-close]')) close();
    // Search from the Index opens the theme's own search (with predictive results)
    if (e.target.closest('[data-dk-search]')) {
      close();
      const summary = document.querySelector('details-modal.header__search summary');
      if (summary) setTimeout(() => summary.click(), 80);
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { close(); closeLb(); } });

  // Bundled Sadie pictures open full screen (the theme's own zoom handles the store's photographs)
  let lb = null;
  const closeLb = () => { if (!lb) return; const el = lb; lb = null; el.classList.remove('is-open'); setTimeout(() => el.remove(), 350); };
  document.addEventListener('click', (e) => {
    const z = e.target.closest('[data-dk-zoom]');
    if (z) {
      lb = document.createElement('div'); lb.className = 'dk-lb';
      lb.innerHTML = '<img alt=""><button type="button" aria-label="Close">&times;</button>';
      lb.querySelector('img').src = z.dataset.dkZoom;
      lb.addEventListener('click', closeLb); document.body.appendChild(lb);
      requestAnimationFrame(() => lb && lb.classList.add('is-open'));
    }
  });

  // Collections: "Show 24 more" adds the next page under the products already showing, so shoppers keep their place.
  // The page numbers stay in the page (hidden) for search engines and for browsers without scripts.
  const moreSetup = () => {
    const box = document.getElementById('ProductGridContainer');
    const grid = box && box.querySelector('ul#product-grid');
    const next = box && box.querySelector('.pagination__item--prev[href]');
    if (!grid || !next || box.querySelector('.dk-more')) return;
    const countEl = document.getElementById('ProductCountDesktop') || document.getElementById('ProductCount');
    const total = parseInt(((countEl && countEl.textContent) || '').replace(/[^0-9]/g, ''), 10) || 0;
    const per = grid.children.length || 24;
    const wrap = document.createElement('div'); wrap.className = 'dk-more';
    wrap.innerHTML = '<p class="dk-more-n"></p><button type="button" class="button button--secondary"></button>';
    const btn = wrap.querySelector('button'), note = wrap.querySelector('p');
    let url = next.href;
    const label = () => {
      const shown = grid.children.length;
      note.textContent = total ? 'Showing ' + shown + ' of ' + total : '';
      btn.textContent = 'Show ' + (total ? Math.min(per, total - shown) : per) + ' more';
    };
    label();
    box.querySelector('.pagination-wrapper').classList.add('dk-more-hide');
    box.appendChild(wrap);
    btn.addEventListener('click', async () => {
      btn.disabled = true; btn.textContent = 'Loading…';
      try {
        const doc = new DOMParser().parseFromString(await (await fetch(url)).text(), 'text/html');
        const items = doc.querySelectorAll('ul#product-grid > li');
        items.forEach((li) => grid.appendChild(document.importNode(li, true)));
        const n = doc.querySelector('#ProductGridContainer .pagination__item--prev[href]');
        if (n && items.length) { url = n.href; btn.disabled = false; label(); }
        else { btn.remove(); note.textContent = 'All ' + grid.children.length + ' shown'; }
      } catch (e) { btn.disabled = false; label(); }
    });
  };
  moreSetup();
  const pgc = document.getElementById('ProductGridContainer');
  if (pgc) new MutationObserver(moreSetup).observe(pgc, { childList: true });

  // Light / dark switch: flips the page, remembers the choice on this device, and labels each switch with what it does next
  const themeLabel = () => {
    const light = document.documentElement.getAttribute('data-theme') === 'light';
    document.querySelectorAll('[data-dk-theme]').forEach((b) => {
      b.setAttribute('aria-label', light ? 'Switch to dark mode' : 'Switch to light mode');
      b.setAttribute('aria-pressed', String(light));
      const t = b.querySelector('.dk-theme-t'); if (t) t.textContent = light ? 'Dark mode' : 'Light mode';
    });
  };
  themeLabel();
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-dk-theme]')) return;
    const root = document.documentElement, light = root.getAttribute('data-theme') !== 'light';
    if (!reducedMotion) { root.classList.add('dk-theme-anim'); setTimeout(() => root.classList.remove('dk-theme-anim'), 450); }
    if (light) root.setAttribute('data-theme', 'light'); else root.removeAttribute('data-theme');
    try { localStorage.setItem('dk-theme', light ? 'light' : 'dark'); } catch (err) {}
    themeLabel();
  });

  // Phones: the category bar scrolls sideways, so start it at the department and page you are on
  const bar = document.querySelector('.dk-cats');
  if (bar && bar.scrollWidth > bar.clientWidth) {
    const on = bar.querySelector('a.is-on:not(.dk-cats-d)') || bar.querySelector('.dk-cats-g.open .dk-cats-d');
    if (on) { const r = on.getBoundingClientRect(), b = bar.getBoundingClientRect(); bar.scrollLeft = Math.max(0, r.left - b.left + bar.scrollLeft - (b.width - r.width) / 2); }
  }

  // The sticky header's height, so full-screen sections and pinned panels sit just under it
  const hdr = document.querySelector('.section-header');
  const setHdr = () => { if (hdr) document.documentElement.style.setProperty('--dk-hdr', hdr.offsetHeight + 'px'); };
  setHdr(); if (hdr && 'ResizeObserver' in window) new ResizeObserver(setHdr).observe(hdr);
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Hero: the letterbox entrance once per visit, then the three photographs open
  const hero = document.querySelector('[data-dk-hero]');
  if (hero) {
    // the opening fills the first screen below the announcement and the menu
    const group = document.querySelectorAll('.shopify-section-group-header-group');
    const pull = () => { let h = 0; group.forEach((s) => { h += s.offsetHeight; }); document.documentElement.style.setProperty('--dk-pull', h + 'px'); };
    pull(); addEventListener('resize', pull); if (document.fonts) document.fonts.ready.then(pull);
    const intro = hero.querySelector('[data-dk-intro]');
    const start = () => hero.classList.add('is-in');
    let seen = false; try { seen = sessionStorage.getItem('dk-intro') === '1'; } catch (e) {}
    // visitors from an ad or a social post decide in seconds, so they go straight to the photos
    const fromAd = /[?&](fbclid|gclid|gbraid|wbraid|ttclid|msclkid|utm_[a-z]+)=/i.test(location.search) || /facebook\.|instagram\.|t\.co\/|tiktok\.|pinterest\./i.test(document.referrer);
    if (fromAd) seen = true;
    if (intro && !seen && !reduced && !(window.Shopify && window.Shopify.designMode)) {
      try { sessionStorage.setItem('dk-intro', '1'); } catch (e) {}
      document.documentElement.style.overflow = 'hidden';
      const end = () => { if (intro.classList.contains('is-out')) return; intro.classList.add('is-out'); document.documentElement.style.overflow = ''; start(); setTimeout(() => intro.remove(), 1400); };
      setTimeout(() => intro.classList.add('is-logo'), 120); setTimeout(end, 2300);
      intro.addEventListener('click', end); addEventListener('wheel', end, { once: true }); addEventListener('keydown', end, { once: true });
    } else { if (intro) intro.remove(); setTimeout(start, 60); }
    const imgs = hero.querySelectorAll('.dk-hero-f img');
    addEventListener('scroll', () => { const y = scrollY; if (reduced || y > innerHeight) return; imgs.forEach((im, i) => { im.style.transform = 'translate3d(0, ' + (y * (0.08 + i * 0.05)) + 'px, 0) scale(1.08)'; }); }, { passive: true });
  }

  // Category tiles: the tile you point at shows large beside them
  const prev = document.querySelector('[data-dk-prev]');
  if (prev && prev.offsetParent !== null) {
    const box = prev.querySelector('[data-dk-prevm]'); let cur = null, t;
    const show = (a) => {
      if (a === cur) return; cur = a;
      document.querySelectorAll('[data-dk-tile]').forEach((x) => x.classList.toggle('is-on', x === a));
      prev.href = a.href; prev.querySelector('[data-dk-prevk]').textContent = a.dataset.dept; prev.querySelector('[data-dk-prevt]').textContent = a.dataset.title; prev.querySelector('[data-dk-prevn]').textContent = a.dataset.line;
      if (!a.dataset.src) return;
      const im = new Image(); im.alt = ''; im.src = a.dataset.src; box.appendChild(im);
      requestAnimationFrame(() => requestAnimationFrame(() => im.classList.add('on')));
      const all = box.querySelectorAll('img'); if (all.length > 2) all[0].remove();
    };
    const tiles = document.querySelectorAll('[data-dk-tile]');
    if (tiles[0]) show(tiles[0]);
    tiles.forEach((a) => a.addEventListener('mouseenter', () => { clearTimeout(t); t = setTimeout(() => show(a), 70); }));
  }

  // How it is made: the step reaching the middle of the screen lights its picture
  document.querySelectorAll('[data-dk-build]').forEach((el) => {
    const imgs = el.querySelectorAll('.dk-build-m img'), steps = el.querySelectorAll('[data-dk-step]'), n = el.querySelector('[data-dk-sn]'); let cur = 0;
    const run = () => {
      const r = el.getBoundingClientRect(), total = r.height - innerHeight; if (total <= 0) return;
      const p = Math.min(1, Math.max(0, -r.top / total)), s = Math.min(steps.length - 1, Math.floor(p * steps.length * 0.999));
      if (s === cur) return; cur = s;
      imgs.forEach((im, i) => im.classList.toggle('on', i === s));
      steps.forEach((li, i) => { li.classList.toggle('on', i === s); li.classList.toggle('done', i < s); });
      if (n) n.textContent = String(s + 1).padStart(2, '0');
    };
    addEventListener('scroll', run, { passive: true }); run();
  });

  // Colour picker: choosing a colour brings forward the photo of her in that colour (gallery photos carry
  // data-dk-colour); a colour with no photo of its own (usually Black) brings back the first photo with no colour.
  const dkHandle = (s) => String(s).toLowerCase().trim().replace(/['"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  document.addEventListener('change', (e) => {
    const el = e.target;
    if (!el.closest || !el.closest('variant-radios, variant-selects')) return;
    const name = String(el.name || '').toLowerCase();
    if (!/colou?r/.test(name) || /hardware/.test(name)) return;
    const want = dkHandle(el.value);
    // After Sense's own variant change, which can put the variant's photo first.
    setTimeout(() => {
      document.querySelectorAll('media-gallery').forEach((g) => {
        if (typeof g.setActiveMedia !== 'function' || !g.querySelector('.dk-media-item[data-dk-colour]:not([data-dk-colour=""])')) return;
        const li = g.querySelector(`.dk-media-item[data-dk-colour="${want}"]`) || g.querySelector('.dk-media-item[data-dk-colour=""]');
        if (li) g.setActiveMedia(li.dataset.mediaId, true);
      });
    }, 60);
  });

  // Lookbook: the strip drifts sideways on its own (the photographs are there twice, so it loops), and stops while
  // someone points at it, touches it or tabs into it; still for people who ask for reduced motion.
  document.querySelectorAll('[data-dk-look]').forEach((r) => {
    if (reduced) return;
    const loopAt = r.querySelector('[data-dk-loop]'), first = r.firstElementChild;
    if (!loopAt || !first) return;
    let on = false, held = false, last = 0, x = 0, wait;
    const span = () => loopAt.offsetLeft - first.offsetLeft;
    const step = (ts) => {
      if (!on) return;
      const dt = last ? Math.min(64, ts - last) : 16; last = ts;
      if (held) x = r.scrollLeft;
      else { x += dt * 0.04; if (x >= span()) x -= span(); r.scrollLeft = x; }
      requestAnimationFrame(step);
    };
    const hold = () => { held = true; clearTimeout(wait); };
    const free = () => { clearTimeout(wait); wait = setTimeout(() => { x = r.scrollLeft; if (x >= span()) x -= span(); held = false; }, 2500); };
    r.addEventListener('pointerenter', hold); r.addEventListener('pointerleave', free);
    r.addEventListener('touchstart', hold, { passive: true }); r.addEventListener('touchend', free, { passive: true });
    r.addEventListener('focusin', hold); r.addEventListener('focusout', free);
    r.addEventListener('wheel', () => { hold(); free(); }, { passive: true });
    new IntersectionObserver((es) => {
      const seen = es[0].isIntersecting;
      if (seen && !on) { on = true; last = 0; x = r.scrollLeft; requestAnimationFrame(step); } else if (!seen) on = false;
    }).observe(r);
  });

  // The store's own photographs stay after the generated ones. Sense moves the chosen variant's photo to the front of
  // the gallery on every option change (sizes too); a gallery with After Dark photos skips that, and the colour picker
  // above brings forward the photo of that colour instead.
  if (window.customElements) customElements.whenDefined('variant-selects').then(() => {
    const proto = customElements.get('variant-selects').prototype, own = proto.updateMedia;
    if (typeof own !== 'function') return;
    proto.updateMedia = function () {
      const g = document.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`);
      if (g && g.querySelector('.dk-media-item')) return;
      return own.apply(this, arguments);
    };
  });
})();
